import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {Option} from '@Components/contextual-menu/components/option';
import type {ContextualMenuHeadingOptionWithViewAllButtonProps} from './contextual-menu-heading-option-with-view-all-button.types';
import styles from './contextual-menu-heading-option-with-view-all-button.module.scss';

export function ContextualMenuHeadingOptionWithViewAllButton({className = '', textClasses = '', ...props}: ContextualMenuHeadingOptionWithViewAllButtonProps): ReactElement<any> {
  const onViewAllClicked = (): void => {
    props.onViewAllClick();
  };

  const getHeadingContent = (): ReactElement<any> => {
    return (
      <div className={`spacing-m-t-4 _full-width ${textClasses}`}>
        <div className="flex-justify-between">
          <Text val={props.text} size={TextSize.XSMALL} bold />
          <Text onClick={onViewAllClicked} className={`_cursor-pointer ${styles.viewAllText}`} val={window.i18next.t('pmwjs_view_all')} size={TextSize.XSMALL} bold />
        </div>
        <div className={`${styles.line} spacing-m-t-1 _full-width`} />
      </div>
    );
  };

  return <Option className={className} key={props.id} optionControl={getHeadingContent()} />;
}
